import React from 'react';

const PromoBanner: React.FC = () => {
  return null; // Component no longer renders anything
};

export default PromoBanner;